import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class OrdersStatusCount extends Model {
  @Expose()
  allCount: number;
  @Expose()
  dispatchedCount: number;
  @Expose()
  stagedCount: number;
}
